var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "container" }, [
    _vm._m(0),
    _c("div", { staticClass: "row mat24 flex-nowrap" }, [
      _c(
        "div",
        { staticClass: "side-bar none-mobile" },
        [
          _c(
            "base-button-group",
            [
              _c(
                "base-button",
                {
                  attrs: { btn11: "" },
                  on: {
                    click: function ($event) {
                      return _vm.$router.push({
                        name: "panel-competition-mail-new",
                        params: _vm.competition,
                        alias: true,
                      })
                    },
                  },
                },
                [_vm._v(" Wyślij e-mail ")]
              ),
              _vm.canAccessSms
                ? _c(
                    "base-button",
                    {
                      attrs: { btn11: "" },
                      on: {
                        click: function ($event) {
                          return _vm.$router.push({
                            name: "panel-competition-sms-new",
                            params: _vm.competition,
                            alias: true,
                          })
                        },
                      },
                    },
                    [_vm._v(" Wyślij SMS ")]
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
      _vm.competition
        ? _c(
            "div",
            { staticClass: "content-wrap" },
            [
              _c("validation-observer", {
                ref: "FormObserver",
                attrs: { tag: "div" },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function ({ handleSubmit }) {
                        return [
                          _c("panel-competition-form-box", [
                            _c("p", [_vm._v("Wiadomości SMS")]),
                            _c("p", { staticClass: "mat16" }, [
                              _vm._v(
                                " SMS zostanie wysłany wyłącznie do uczestników, którzy zapisali się na "
                              ),
                              _c("b", [_vm._v(_vm._s(_vm.competition.name))]),
                              _vm._v(
                                " i podali numer telefonu. Pamiętaj, że celem wysyłki jest komunikat dotyczący organizacji Twoich zawodów (np. zmiana godziny startu lub odwołanie imprezy). Wiadomość nie powinna być treścią marketingową ani spamem. "
                              ),
                            ]),
                          ]),
                          _c(
                            "panel-competition-form-box",
                            { staticClass: "mat16" },
                            [
                              _c(
                                "div",
                                { staticClass: "col-12 col-lg-8" },
                                [
                                  _c("validation-provider", {
                                    staticClass: "scroll-margin relative",
                                    attrs: {
                                      name: "information",
                                      rules: "required",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function ({ errors }) {
                                            return [
                                              _c("panel-input-area", {
                                                ref: "messageArea",
                                                attrs: {
                                                  label: "Treść SMS",
                                                  rows: 8,
                                                  error: errors.information,
                                                },
                                                on: {
                                                  "update:error": function (
                                                    $event
                                                  ) {
                                                    return _vm.$set(
                                                      errors,
                                                      "information",
                                                      $event
                                                    )
                                                  },
                                                },
                                                model: {
                                                  value: _vm.form.information,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.form,
                                                      "information",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "form.information",
                                                },
                                              }),
                                              errors[0]
                                                ? _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "input-error-alt",
                                                    },
                                                    [_vm._v("Pole wymagane")]
                                                  )
                                                : _vm._e(),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      true
                                    ),
                                  }),
                                  _vm.form.information
                                    ? _c(
                                        "div",
                                        { staticClass: "segment-info mat8" },
                                        [
                                          _c(
                                            "span",
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.segmentInfo
                                                      .adjustedLength
                                                  ) +
                                                  " znaków · " +
                                                  _vm._s(
                                                    _vm.segmentInfo.encoding ===
                                                      "gsm"
                                                      ? "GSM-7bit"
                                                      : "UCS-2"
                                                  ) +
                                                  " · "
                                              ),
                                              _vm.segmentInfo.segments != null
                                                ? [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          _vm.segmentInfo
                                                            .segments
                                                        ) +
                                                        " " +
                                                        _vm._s(
                                                          _vm.segmentInfo
                                                            .segments === 1
                                                            ? "część SMS"
                                                            : "części SMS"
                                                        ) +
                                                        " "
                                                    ),
                                                  ]
                                                : [_vm._v("—")],
                                            ],
                                            2
                                          ),
                                          !_vm.segmentInfo.isValid &&
                                          _vm.form.information.length > 0
                                            ? _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "segment-info__error",
                                                },
                                                [
                                                  _vm._v(
                                                    " SMS jest pusty lub za długi (max " +
                                                      _vm._s(_vm.maxSegments) +
                                                      " części). "
                                                  ),
                                                ]
                                              )
                                            : _vm._e(),
                                        ]
                                      )
                                    : _vm._e(),
                                ],
                                1
                              ),
                              _c("div", { staticClass: "col-12 col-lg-3" }, [
                                _c("p", { staticClass: "tags-title mat24" }, [
                                  _vm._v("Znaczniki personalizacji"),
                                ]),
                                _c("p", { staticClass: "tags-desc" }, [
                                  _vm._v(
                                    "Kliknij znacznik, aby wstawić go do treści:"
                                  ),
                                ]),
                                _c(
                                  "ul",
                                  { staticClass: "tags-list" },
                                  _vm._l(_vm.availableTags, function (tag) {
                                    return _c("li", { key: tag.key }, [
                                      _c(
                                        "button",
                                        {
                                          staticClass: "tag-btn",
                                          attrs: { type: "button" },
                                          on: {
                                            click: function ($event) {
                                              return _vm.insertTag(tag.key)
                                            },
                                          },
                                        },
                                        [_vm._v(" [" + _vm._s(tag.key) + "] ")]
                                      ),
                                      _c("span", { staticClass: "tag-label" }, [
                                        _vm._v(_vm._s(tag.label)),
                                      ]),
                                    ])
                                  }),
                                  0
                                ),
                              ]),
                            ]
                          ),
                          _c(
                            "panel-competition-form-box",
                            { staticClass: "mat16" },
                            [
                              _c("div", { staticClass: "w-full mab16" }, [
                                _c("p", { staticClass: "title" }, [
                                  _vm._v("Opcje wysyłki"),
                                ]),
                              ]),
                              _c("div", { staticClass: "radio-wrap" }, [
                                _c(
                                  "div",
                                  { staticClass: "radio-wrap-column" },
                                  [
                                    _c("label", { staticClass: "mab8" }, [
                                      _vm._v("Wyślij do uczestników"),
                                    ]),
                                    _vm._l(
                                      _vm.sendPaymentOptions,
                                      function (option) {
                                        return _c("panel-input-base-radio", {
                                          key: option.value,
                                          attrs: {
                                            name: "formSendPayment",
                                            option: option,
                                          },
                                          model: {
                                            value: _vm.form.send_payment,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.form,
                                                "send_payment",
                                                $$v
                                              )
                                            },
                                            expression: "form.send_payment",
                                          },
                                        })
                                      }
                                    ),
                                  ],
                                  2
                                ),
                                _c(
                                  "div",
                                  { staticClass: "radio-wrap-column" },
                                  [
                                    _c("label", { staticClass: "mab8" }, [
                                      _vm._v(
                                        "Wyślij do uczestników z wybranej kategorii"
                                      ),
                                    ]),
                                    _vm._l(
                                      _vm.classificationOptions,
                                      function (option) {
                                        return _c("panel-input-base-radio", {
                                          key: option.value,
                                          attrs: {
                                            name: "formSendClassification",
                                            option: option,
                                          },
                                          model: {
                                            value: _vm.form.send_classification,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.form,
                                                "send_classification",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "form.send_classification",
                                          },
                                        })
                                      }
                                    ),
                                  ],
                                  2
                                ),
                                _c(
                                  "div",
                                  { staticClass: "radio-wrap-column" },
                                  [
                                    _c("p", [_vm._v("Liczba odbiorców")]),
                                    !_vm.loadingCount
                                      ? _c(
                                          "b",
                                          {
                                            staticClass: "recipient-count",
                                            class: {
                                              "recipient-count--zero":
                                                _vm.recipientCount === 0,
                                            },
                                          },
                                          [_vm._v(_vm._s(_vm.recipientCount))]
                                        )
                                      : _c(
                                          "span",
                                          {
                                            staticClass:
                                              "recipient-count recipient-count--loading",
                                          },
                                          [_vm._v("Ładowanie...")]
                                        ),
                                    !_vm.loadingCount &&
                                    _vm.recipientCount === 0
                                      ? _c(
                                          "p",
                                          {
                                            staticClass:
                                              "no-recipients-warning",
                                          },
                                          [
                                            _vm._v(
                                              " Brak odbiorców z numerem telefonu spełniających wybrane kryteria. "
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                  ]
                                ),
                              ]),
                            ]
                          ),
                          _vm.submitError
                            ? _c("p", { staticClass: "submit-error" }, [
                                _vm._v(_vm._s(_vm.submitError)),
                              ])
                            : _vm._e(),
                          _vm.submitSuccess
                            ? _c("p", { staticClass: "submit-success" }, [
                                _vm._v(_vm._s(_vm.submitSuccess)),
                              ])
                            : _vm._e(),
                          _c(
                            "div",
                            { staticClass: "actions-wrap" },
                            [
                              _c(
                                "base-button",
                                {
                                  attrs: {
                                    btn1: "",
                                    short: "",
                                    disabled:
                                      _vm.isWaiting ||
                                      _vm.recipientCount === 0 ||
                                      _vm.loadingCount ||
                                      !_vm.segmentInfo.isValid,
                                  },
                                  on: {
                                    click: function ($event) {
                                      return handleSubmit(_vm.openConfirmModal)
                                    },
                                  },
                                },
                                [
                                  !_vm.isWaiting
                                    ? _c("span", [_vm._v("Utwórz wysyłkę SMS")])
                                    : _c("span", [_vm._v("Zapisywanie...")]),
                                ]
                              ),
                            ],
                            1
                          ),
                        ]
                      },
                    },
                  ],
                  null,
                  false,
                  1028580031
                ),
              }),
              _c("div", { staticClass: "mailings-section mat32" }, [
                _c("p", { staticClass: "mailings-section__title" }, [
                  _vm._v("Wysłane wiadomości SMS"),
                ]),
                _vm.loadingSmses
                  ? _c("div", { staticClass: "mailings-loading" }, [
                      _vm._v("Ładowanie listy SMS..."),
                    ])
                  : _vm.smsError
                  ? _c("div", { staticClass: "mailings-error" }, [
                      _vm._v(_vm._s(_vm.smsError)),
                    ])
                  : _c("table", { staticClass: "mailings-table" }, [
                      _vm._m(1),
                      _c(
                        "tbody",
                        [
                          _vm.smses.length === 0
                            ? _c("tr", [
                                _c(
                                  "td",
                                  {
                                    staticClass: "mailings-table__empty",
                                    attrs: { colspan: "6" },
                                  },
                                  [_vm._v("Brak wysłanych wiadomości SMS")]
                                ),
                              ])
                            : _vm._e(),
                          _vm._l(_vm.smses, function (sms) {
                            return _c(
                              "tr",
                              {
                                key: sms.id,
                                staticClass: "mailings-table__row",
                                on: {
                                  click: function ($event) {
                                    return _vm.openSmsDetail(sms.id)
                                  },
                                },
                              },
                              [
                                _c("td", { staticClass: "sms-preview" }, [
                                  _vm._v(
                                    _vm._s(_vm.truncate(sms.information, 60))
                                  ),
                                ]),
                                _c("td", [_vm._v(_vm._s(sms.smses_count))]),
                                _c("td", [
                                  _vm._v(
                                    _vm._s(_vm.formatPrice(sms.price)) + " zł"
                                  ),
                                ]),
                                _c("td", [
                                  _c(
                                    "span",
                                    {
                                      staticClass: "status-badge",
                                      class: `status-badge--${
                                        sms.status || "pending"
                                      }`,
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(_vm.statusLabel(sms.status)) +
                                          " "
                                      ),
                                    ]
                                  ),
                                ]),
                                _c("td", [
                                  _vm._v(
                                    " " +
                                      _vm._s(sms.smses_sent ?? "—") +
                                      " / " +
                                      _vm._s(sms.smses_not_sent ?? "—") +
                                      " "
                                  ),
                                ]),
                                _c("td", [
                                  _vm._v(
                                    _vm._s(_vm.formatUnixDate(sms.sended))
                                  ),
                                ]),
                              ]
                            )
                          }),
                        ],
                        2
                      ),
                    ]),
              ]),
              _c("modal", {
                ref: "confirmModal",
                staticClass: "sms-confirm-modal",
                attrs: { "body-class": "h-auto" },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "header",
                      fn: function () {
                        return [
                          _c("span", [_vm._v("Potwierdzenie wysyłki SMS")]),
                        ]
                      },
                      proxy: true,
                    },
                    {
                      key: "body",
                      fn: function () {
                        return [
                          _c(
                            "div",
                            { staticClass: "sms-confirm-modal__body" },
                            [
                              _c("p", [
                                _vm._v(" Kwota "),
                                _c("b", [
                                  _vm._v(
                                    "1 zł × " + _vm._s(_vm.recipientCount)
                                  ),
                                ]),
                                _vm._v(
                                  " uczestników zostanie dopisana do Twojego rachunku, a faktura zostanie wystawiona na koniec miesiąca. "
                                ),
                              ]),
                            ]
                          ),
                        ]
                      },
                      proxy: true,
                    },
                    {
                      key: "footer",
                      fn: function () {
                        return [
                          _c(
                            "button",
                            {
                              staticClass: "sms-confirm-modal__cancel",
                              attrs: {
                                type: "button",
                                disabled: _vm.isWaiting,
                              },
                              on: { click: _vm.closeConfirmModal },
                            },
                            [_vm._v(" Anuluj ")]
                          ),
                          _c(
                            "base-button",
                            {
                              attrs: { btn1: "", disabled: _vm.isWaiting },
                              on: { click: _vm.submit },
                            },
                            [
                              !_vm.isWaiting
                                ? _c("span", [_vm._v("Akceptuję i wyślij")])
                                : _c("span", [_vm._v("Wysyłanie...")]),
                            ]
                          ),
                        ]
                      },
                      proxy: true,
                    },
                  ],
                  null,
                  false,
                  1579278748
                ),
              }),
              _c("modal", {
                ref: "smsModal",
                attrs: { size: "xl" },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "header",
                      fn: function () {
                        return [_c("span", [_vm._v("Szczegóły SMS")])]
                      },
                      proxy: true,
                    },
                    {
                      key: "body",
                      fn: function () {
                        return [
                          _vm.loadingDetail
                            ? _c("div", { staticClass: "modal-loading" }, [
                                _vm._v("Ładowanie szczegółów..."),
                              ])
                            : _vm.selectedSms
                            ? _c("div", { staticClass: "mailing-detail" }, [
                                _c(
                                  "div",
                                  { staticClass: "mailing-detail__row" },
                                  [
                                    _c(
                                      "span",
                                      { staticClass: "mailing-detail__label" },
                                      [_vm._v("Status:")]
                                    ),
                                    _c(
                                      "span",
                                      {
                                        staticClass: "status-badge",
                                        class: `status-badge--${
                                          _vm.selectedSms.status || "pending"
                                        }`,
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.statusLabel(
                                                _vm.selectedSms.status
                                              )
                                            ) +
                                            " "
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                                _c(
                                  "div",
                                  { staticClass: "mailing-detail__row" },
                                  [
                                    _c(
                                      "span",
                                      { staticClass: "mailing-detail__label" },
                                      [_vm._v("Odbiorcy:")]
                                    ),
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(_vm.selectedSms.smses_count)
                                      ),
                                    ]),
                                  ]
                                ),
                                _c(
                                  "div",
                                  { staticClass: "mailing-detail__row" },
                                  [
                                    _c(
                                      "span",
                                      { staticClass: "mailing-detail__label" },
                                      [_vm._v("Cena:")]
                                    ),
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.formatPrice(_vm.selectedSms.price)
                                        ) + " zł"
                                      ),
                                    ]),
                                  ]
                                ),
                                _c(
                                  "div",
                                  { staticClass: "mailing-detail__row" },
                                  [
                                    _c(
                                      "span",
                                      { staticClass: "mailing-detail__label" },
                                      [_vm._v("Wysłano / Błędy:")]
                                    ),
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.selectedSms.smses_sent ?? "—"
                                        ) +
                                          " / " +
                                          _vm._s(
                                            _vm.selectedSms.smses_not_sent ??
                                              "—"
                                          )
                                      ),
                                    ]),
                                  ]
                                ),
                                _c(
                                  "div",
                                  { staticClass: "mailing-detail__row" },
                                  [
                                    _c(
                                      "span",
                                      { staticClass: "mailing-detail__label" },
                                      [_vm._v("Data utworzenia:")]
                                    ),
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.formatUnixDate(
                                            _vm.selectedSms.sended
                                          )
                                        )
                                      ),
                                    ]),
                                  ]
                                ),
                                _c(
                                  "div",
                                  { staticClass: "mailing-detail__row" },
                                  [
                                    _c(
                                      "span",
                                      { staticClass: "mailing-detail__label" },
                                      [_vm._v("Opłacono:")]
                                    ),
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.formatDate(
                                            _vm.selectedSms.paid_at
                                          )
                                        )
                                      ),
                                    ]),
                                  ]
                                ),
                                _c(
                                  "div",
                                  { staticClass: "mailing-detail__row" },
                                  [
                                    _c(
                                      "span",
                                      { staticClass: "mailing-detail__label" },
                                      [_vm._v("Kategoria:")]
                                    ),
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.selectedSms
                                            .players_classification || "—"
                                        )
                                      ),
                                    ]),
                                  ]
                                ),
                                _c(
                                  "div",
                                  { staticClass: "mailing-detail__row" },
                                  [
                                    _c(
                                      "span",
                                      { staticClass: "mailing-detail__label" },
                                      [_vm._v("Płatność:")]
                                    ),
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.paymentFilterLabel(
                                            _vm.selectedSms.players_pay
                                          )
                                        )
                                      ),
                                    ]),
                                  ]
                                ),
                                _vm.selectedSms.information
                                  ? _c(
                                      "div",
                                      {
                                        staticClass:
                                          "mailing-detail__row mailing-detail__row--col",
                                      },
                                      [
                                        _c(
                                          "span",
                                          {
                                            staticClass:
                                              "mailing-detail__label",
                                          },
                                          [_vm._v("Treść:")]
                                        ),
                                        _c(
                                          "pre",
                                          {
                                            staticClass:
                                              "mailing-detail__content",
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.selectedSms.information
                                              )
                                            ),
                                          ]
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                                _vm.selectedSms.smses_error
                                  ? _c(
                                      "div",
                                      {
                                        staticClass:
                                          "mailing-detail__row mailing-detail__row--col",
                                      },
                                      [
                                        _c(
                                          "span",
                                          {
                                            staticClass:
                                              "mailing-detail__label",
                                          },
                                          [_vm._v("Błędy:")]
                                        ),
                                        _c(
                                          "p",
                                          {
                                            staticClass:
                                              "mailing-detail__error-list",
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.selectedSms.smses_error
                                              )
                                            ),
                                          ]
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                              ])
                            : _vm._e(),
                        ]
                      },
                      proxy: true,
                    },
                    {
                      key: "footer",
                      fn: function () {
                        return [
                          _c("div"),
                          _c(
                            "base-button",
                            {
                              attrs: { btn2: "", short: "" },
                              on: {
                                click: function ($event) {
                                  return _vm.$refs.smsModal.closeModal()
                                },
                              },
                            },
                            [_vm._v("Zamknij")]
                          ),
                        ]
                      },
                      proxy: true,
                    },
                  ],
                  null,
                  false,
                  1878787143
                ),
              }),
            ],
            1
          )
        : _vm._e(),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "row mat32" }, [
      _c("div", { staticClass: "col-12 title" }, [_vm._v("Wiadomości")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("Treść")]),
        _c("th", [_vm._v("Odbiorcy")]),
        _c("th", [_vm._v("Cena")]),
        _c("th", [_vm._v("Status")]),
        _c("th", [_vm._v("Wysłano / Błędy")]),
        _c("th", [_vm._v("Data")]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }